import { appConstants } from "../constants/appConstants"

function setAccessToken(accessToken: any) {
  function loadData(data: any) {
    return { type: appConstants.ACCESS_TOKEN, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(accessToken))
  }
}

function reset() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.RESET,
    })
  }
}

export const authAction = {
  setAccessToken,
  reset
}

export default authAction
